export default __webpack_public_path__ + "static/media/nyc.c93bf6f6.jpeg";